import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';

import * as styles from './CollectionActionModal.css';

export const DeleteModal = ({
  isOpen,
  close,
  onDelete,
  isConfirming = false,
}: {
  isOpen: boolean;
  close: () => void;
  onDelete: () => void;
  isConfirming?: boolean;
}) => (
  <Modal
    isOpen={isOpen}
    onClose={close}
    title="Deleting?"
    modalClassName="w-full md:w-[650px]"
    centerContent={true}
  >
    <div className="flex flex-col gap-6">
      <Typography variant="body" size="large" fontWeight="normal">
        This action will <strong>delete</strong> the collection and archive all
        workouts/classes within the collection. Are you sure?
      </Typography>
      <div className="flex gap-4 justify-center">
        <Button
          variant="text"
          color="neutral"
          onClick={close}
          className={styles.actionButton}
        >
          Cancel
        </Button>
        <Button
          color="neutral"
          onClick={onDelete}
          className={styles.actionButton}
          disabled={isConfirming}
        >
          Yes, delete
        </Button>
      </div>
    </div>
  </Modal>
);
